import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';

function LoginInstitutionalGreeting({ notifications }) {
  if (!notifications) {
    return null;
  }

  return (
    <div className="login-page-right-notification">
      {notifications.CUSTOM_RIGHT &&
        notifications.CUSTOM_RIGHT?.map((notification) => (
          <div key={`right-notification-${notification}`} className="notification-container">
            <div className="notification--info rx-border-none">
              <div className="notification--icon">i</div>
              <InnerHTML
                tag="div"
                className="notification--content"
                html={notification}
                mode="escape"
                allowedTags={allowedTagsDefault.concat('a')}
                allowedAttributes={['href', 'target']}
              />
            </div>
          </div>
        ))}
      {notifications.INSTITUTIONAL_GREETING && (
        <div className="notification-container">
          <InnerHTML
            tag="div"
            className="notification-container--message"
            html={notifications.INSTITUTIONAL_GREETING}
            mode="escape"
            allowedTags={allowedTagsDefault.concat('a')}
            allowedAttributes={['href', 'target']}
          />
        </div>
      )}
    </div>
  );
}

LoginInstitutionalGreeting.propTypes = {
  notifications: PropTypes.object,
};

export default LoginInstitutionalGreeting;
